@if (isLoading) {
  <div
    class="min-h-screen bg-cover bg-center pb-page-bottom flex h-90-screen flex-col items-center justify-start px-5 pt-20 align-middle"
    [style.backgroundImage]="backgroundImage ? 'url(' + backgroundImage.url + ')' : 'initial'"
  >
    <!-- Payment steps checklist -->
    <div class="w-full max-w-md text-left">
      <!-- Step 1: Payment validated -->
      <div class="step-fade-in mb-4 flex items-center">
        <span class="mr-3">
          <i class="icon icon-n-check text-2xl text-success-600"></i>
        </span>
        <span class="font-accent text-lg font-bold text-neutral-800">
          {{ 'pay-at-table.payment-confirmation.payment-validated' | translate }}
        </span>
      </div>
      <!-- Step 2: Finalizing with restaurant (animated) -->
      @if (showSecondStep) {
        <div class="step-slide-down mb-4 flex items-center">
          <span class="mr-3">
            <img
              src="assets/images/spinner.svg"
              alt="Loading"
              class="h-6 w-6"
            />
          </span>
          <span class="font-accent text-lg font-bold text-neutral-800">
            {{ 'pay-at-table.payment-confirmation.finalizing-with-restaurant' | translate }}
          </span>
        </div>
      }
    </div>
    <!-- Progressive messages -->
    <div class="mt-4 text-center">
      <!-- Message after 20 seconds -->
      @if (showLongerMessage && !showIssueMessage) {
        <p class="mb-2 text-neutral-600">
          {{ 'pay-at-table.payment-confirmation.operation-taking-longer' | translate }}
        </p>
      }
      <!-- Message after 60 seconds (replaces the above) -->
      @if (showIssueMessage) {
        <p class="mb-2 text-neutral-600">
          {{ 'pay-at-table.payment-confirmation.payment-confirmation-issue' | translate }}
        </p>
      }
      <!-- Reference message after 30 seconds -->
      @if (showReferenceMessage) {
        <p class="text-sm text-neutral-500">
          {{ 'pay-at-table.payment-confirmation.transaction-reference' | translate }} :
          {{ transactionId }}
        </p>
      }
    </div>
  </div>
}
@if (!isLoading) {
  <div
    class="min-h-screen bg-cover bg-center pb-page-bottom"
    [style.backgroundImage]="backgroundImage ? 'url(' + backgroundImage.url + ')' : 'initial'"
  >
    <!--  Success text -->
    <div class="flex items-center justify-center px-5 pb-3 pt-7 md:w-8/12">
      <span><i class="icon icon-n-check text-3xl text-success-600 md:text-4xl"></i></span>
      <p class="text-accent ml-3 text-2xl font-bold leading-8 text-neutral-800 md:ml-4 md:text-5xl">
        {{ 'pay-at-table.payment-confirmation.payment-confirmed' | translate }}
      </p>
    </div>
    <!--  Remaining amount to pay -->
    @if (((outstandingAmount$ | async) ?? 0) > 0) {
      <div class="px-5 pb-3 md:w-8/12">
        <div class="mb-3 flex flex-col rounded-m bg-neutral-100 p-5 text-center md:mb-8 md:p-6">
          <p class="font-accent text-md font-bold text-neutral-800 md:text-29px">
            {{ 'pay-at-table.payment-confirmation.waiting-guests' | translate }}
          </p>
        </div>
      </div>
    }
    <!-- Custom blocks  -->
    <app-block-list [blockIdList]="body"></app-block-list>
    <!-- receive invoice -->
    @if (transaction) {
      <div class="px-5">
        <app-email-receipt-atom
          [icon]="'icon-receipt_long'"
          [title]="'pay-at-table.payment-confirmation.receipt.receipt-by-email' | translate"
          [text]="'pay-at-table.payment-confirmation.receipt.description' | translate"
          (openModal)="openModalReceipt()"
        ></app-email-receipt-atom>
      </div>
    }
  </div>
}

@if (isTransactionCancelled) {
  <div
    class="fixed inset-0 z-100 flex flex-col items-center justify-center bg-error-50 px-5 text-center"
  >
    <p class="font-accent mb-3 text-2xl font-bold leading-8 text-error-600">
      {{ 'pay-at-table.payment-confirmation.payment-refused' | translate }}
    </p>
    <p class="mb-6 font-base text-error-600">
      {{ 'pay-at-table.payment-confirmation.payment-refused-desc' | translate }}
    </p>
    <app-button-atom
      class="w-full"
      [label]="'pay-at-table.payment-confirmation.payment-refused-button' | translate"
      [full]="true"
      (click)="goToOverview()"
    ></app-button-atom>
  </div>
}
